import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const ElectronicIcon: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M11.25 11.25H0.416667C0.30616 11.25 0.200179 11.2939 0.122039 11.372C0.0438988 11.4502 0 11.5562 0 11.6667C0 11.7772 0.0438988 11.8832 0.122039 11.9613C0.200179 12.0394 0.30616 12.0833 0.416667 12.0833H11.25C11.3605 12.0833 11.4665 12.0394 11.5446 11.9613C11.6228 11.8832 11.6667 11.7772 11.6667 11.6667C11.6667 11.5562 11.6228 11.4502 11.5446 11.372C11.4665 11.2939 11.3605 11.25 11.25 11.25Z"
					fill="#A09FA7"
				/>
				<path
					d="M5.83184 10.6167L10.2527 6.19583C10.3209 6.11613 10.3566 6.01359 10.3526 5.90873C10.3485 5.80386 10.305 5.70439 10.2308 5.63018C10.1566 5.55598 10.0571 5.5125 9.95228 5.50845C9.84741 5.5044 9.74488 5.54007 9.66517 5.60833L6.24851 9.02083V0.416667C6.24851 0.30616 6.20461 0.200179 6.12647 0.122039C6.04833 0.0438988 5.94235 0 5.83184 0C5.72133 0 5.61535 0.0438988 5.53721 0.122039C5.45907 0.200179 5.41517 0.30616 5.41517 0.416667V9.02083L2.00267 5.60833C1.96532 5.56472 1.91936 5.52929 1.86766 5.50428C1.81597 5.47927 1.75966 5.46522 1.70228 5.463C1.6449 5.46078 1.58768 5.47045 1.53421 5.4914C1.48074 5.51235 1.43218 5.54412 1.39157 5.58473C1.35096 5.62534 1.31919 5.6739 1.29824 5.72737C1.27729 5.78083 1.26763 5.83806 1.26984 5.89544C1.27206 5.95282 1.28611 6.00913 1.31112 6.06082C1.33613 6.11251 1.37156 6.15848 1.41517 6.19583L5.83184 10.6167Z"
					fill="#A09FA7"
				/>
			</svg>
		</div>
	);
};
